<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          top
          v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_PAGINATION_START)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="startConsultation(item)">
              <v-icon color="secondary" v-bind="attrs" v-on="on">
                mdi-doctor
              </v-icon>
            </v-btn>
          </template>
          <span>Atender</span>
        </v-tooltip>
        <v-tooltip
          top
          v-if="$utilFront.withPermission($prm.MODULE_TELEMEDICINE_CANCEL)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="checkCancel(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-stop
              </v-icon>
            </v-btn>
          </template>
          <span>Cancelar</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.startTime`]="{ item }">
        {{ $utilFront.formatDateTime(item.startTime) }}
      </template>
    </v-data-table>

    <!-- Modal de cancelación existente -->
    <v-dialog
      v-model="dialogCancelation"
      v-if="dialogCancelation"
      persistent
      max-width="70%"
    >
      <cancelation-modal
        ref="cancelationModal"
        :dataModal="dataModal"
        @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation"
      />
    </v-dialog>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import CalculatorsSomatometryRequest from "@/core/request/CalculatorsSomatometryRequest"
export default {
  name: "TelemedicineToStartTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
  },
  components: {
    MenuCrud,
    CancelationModal,
  },
  data() {
    return {
      idPatient: null,
      appointmentDialog: false,
      dataModal: {},
      dialogCancelation: false,
      calculatorsData: [],
      headers: [
        {
          text: "Id Consulta",
          value: "idMedicalPractice",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Nombre del paciente",
          value: "fullName",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha y hora de solicitud",
          value: "startTime",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },

  methods: {
    
    startConsultation(item) {
    const payload = {
      evaluationTypes: [9, 10, 11],
      idPerson: item.idPerson,
      idClinicalEvent: item.idClinicalEvent || null,
    };

    CalculatorsSomatometryRequest.getCalculatorsSomatometry(payload)
      .then((res) => {
        this.calculatorsData = res.data;
        localStorage.setItem("calculatorsData", JSON.stringify(res.data));
        this.get(item.idMedicalPractice, 2, true);
      })
      .catch((error) => {
        console.error("Error al obtener calculadoras: ", error);
      });
  },
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
  },
};
</script>
